<template>
  <dialog-full-screen :dialog="studentTrainingDialogMicro" titleName="Treino" @close="closeDialog()">
    <v-container>

      <student-header-info :cycle="'micro'" />

      <template v-if="isEmptyState">
        <v-row justify="center" align="center" class="py-12" style="flex-direction: column;">
          <v-col>
            <v-card elevation=0 height="277px">
              <v-img contain height="90px" :src="require('@/assets/images/students/show/no-data-training.svg')"></v-img>

              <v-card-text class="text-center mb-0">
                Ainda não há nenhum treino cadastrado.
              </v-card-text>

              <v-card-actions class="justify-center">
                <v-btn v-if="!readonly" @click="newTraining()" color="primary">novo treino</v-btn>
                <v-btn v-if="!readonly" @click="enableCopyStudent()" color="primary">copiar treino</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col>
            <v-card v-show="isCopyEnable" elevation="0">
              <v-card-actions class="justify-center mb-5">
                <v-row>
                  <v-col>
                    <v-checkbox
                      v-model="copyMode"
                      :value="'sameStudent'"
                      :true-value="'sameStudent'"
                      :false-value="'otherStudent'"
                      label="Mesmo Aluno"
                      color="primary"
                      hide-details
                      dense
                      @change="clearStudent"
                    />
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="copyMode"
                      :value="'otherStudent'"
                      :true-value="'otherStudent'"
                      :false-value="'sameStudent'"
                      label="Outro Aluno"
                      color="primary"
                      hide-details
                      dense
                      @change="clearStudent"
                    />
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="copyMode"
                      :value="'myLibrary'"
                      :true-value="'myLibrary'"
                      :false-value="'sameStudent'"
                      label="Minha Biblioteca"
                      color="primary"
                      hide-details
                      dense
                    />
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="copyMode"
                      :value="'adminLibrary'"
                      :true-value="'adminLibrary'"
                      :false-value="'sameStudent'"
                      label="Biblioteca FisicSoft"
                      color="primary"
                      hide-details
                      dense
                    />
                  </v-col>
                </v-row>
              </v-card-actions>
              <v-card-actions v-if="copyMode === 'otherStudent'" class="justify-center">
                <v-row>
                  <v-col>
                    <v-text-field v-model="studentcopy" label='Código Aluno' filled required />
                  </v-col>
                  <v-col class="justify-center">
                    <v-btn v-if="!readonly" @click="loadMicrocycle()" color="primary">Pesquisar</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
              <v-card-actions class="justify-center">
                <v-row>
                  <v-col>
                    <v-text-field v-model="studentSel" label='Aluno Selecionado' filled required disabled />
                  </v-col>
                </v-row>
              </v-card-actions>
              <v-card-actions v-if="['myLibrary', 'adminLibrary'].includes(copyMode)" class="justify-center">
                <v-select v-model="microCopy" label="Selecione o treino que deseja copiar"
                  :items="trainingsFromLibrary" return-object item-value="id" item-text="name" item-color="primary"
                  :menu-props="{ nudgeBottom: '64px' }" chips hide-details filled dense>
                  <template slot="item" slot-scope="data">
                    Treino: {{ data.item.name }}
                  </template>
                </v-select>
              </v-card-actions>
              <v-card-actions v-else class="justify-center">
                <v-select v-model="microCopy" label="Selecione o Microciclo que deseja copiar o treino"
                  :items="trainingListToCopy" return-object item-value="id" item-text="name" item-color="primary"
                  :menu-props="{ nudgeBottom: '64px' }" chips hide-details filled dense>

                  <template slot="item" slot-scope="data">
                    <b>Macro:</b> &nbsp;{{ (data.item.mesocycle ? data.item.mesocycle.macrocycle_name : data.item.macrocycle.name) }}

                    &nbsp;<b>Meso:</b>&nbsp;
                    <span v-html="data.item.mesocycle ? `${data.item.mesocycle.name} <b>Micro:</b> ${data.item.name}` : `${data.item.name}`"></span>
                </template>
                </v-select>
              </v-card-actions>
              <v-card-actions class="justify-center">
                <v-btn v-if="!readonly" @click="copyTraining()" color="primary">Copiar treino</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row no-gutters class="mt-5">
          <div
            style="overflow-x: hidden; white-space: nowrap; width: 100%; overflow-y: hidden;"
          >
            <v-row
              class="flex-nowrap justify-center"
              style="min-width: max-content;"
            >
              <!-- <v-slide-group> -->
                <v-col cols="auto" class="pr-0 mb-2" v-for="(weekday, idx) in week" :key="idx">
              <v-card width="163px" height="100%">
                <v-card-title class="justify-center"
                  :class="isEmptyWeekdayTraining(weekday, microcycleToBeEvaluated.trainings) ? 'lightgrey text--secondary' : 'secondary white--text'">
                  {{ weekday.name }}
                </v-card-title>

                <template v-if="isEmptyWeekdayTraining(weekday, microcycleToBeEvaluated.trainings)">
                  <v-img contain height="72px" class="mt-8"
                    :src="require('@/assets/images/students/show/no-data-training.svg')"></v-img>
                  <v-card-text class="text-center mb-0 caption">
                    Não há treino neste dia.
                  </v-card-text>
                </template>
                <template v-else>
                  <v-row justify="center" class="mx-0 grey lighten-4">
                    <v-subheader>
                      <span class="primary--text font-weight-bold justify-center">{{
                        getMuscleGroupSeriesFromWeekday(weekday,
                          microcycleToBeEvaluated.trainings).name }}</span>
                    </v-subheader>
                  </v-row>
                  <template
                    v-if="getMuscleGroupSeriesFromWeekday(weekday, microcycleToBeEvaluated.trainings).worked_muscle_groups.length">
                    <v-row class="pa-0 px-3 mt-n4" style="font-size: 10px;">
                      <v-col class="grey lighten-4" cols="8">Grupo muscular</v-col>
                      <v-col class="grey lighten-4 text-right" cols="4">Séries</v-col>
                    </v-row>
                    <v-list-item
                      v-for="(workedMuscleGroup, idx) in getMuscleGroupSeriesFromWeekday(weekday, microcycleToBeEvaluated.trainings).worked_muscle_groups"
                      :key="`muscle-group${idx}`">
                      <v-list-item-subtitle class="text-left">{{ workedMuscleGroup.name }} </v-list-item-subtitle>
                      <v-list-item-action class="pl-8 ml-n8">{{ workedMuscleGroup.seriesAmount }} </v-list-item-action>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <template
                      v-if="getMuscleGroupSeriesFromWeekday(weekday, microcycleToBeEvaluated.trainings).exercisesCount">
                      <v-img contain height="72px" class="mt-8"
                        :src="require('@/assets/images/students/show/no-resistence-training.svg')"></v-img>
                      <v-card-text class="text-center mb-0 caption">
                        Não há exercícios resistidos neste treino.
                      </v-card-text>
                    </template>
                    <template v-else>
                      <v-img contain height="72px" class="mt-8"
                        :src="require('@/assets/images/students/show/no-data-training.svg')"></v-img>
                      <v-card-text class="text-center mb-0 caption">
                        Não há exercícios neste treino.
                      </v-card-text>
                    </template>
                  </template>
                </template>
              </v-card>
            </v-col>
              <!-- </v-slide-group> -->
            </v-row>
          </div>
        </v-row>

        <v-row class="justify-center py-0">
          <v-col cols="12">
            <v-card height="100%">
              <v-card-title class="justify-center primary white--text">
                Total da Semana
              </v-card-title>

              <v-row no-gutters>
                <v-col class="grey lighten-4" style="max-width: 150px;">
                  <v-row class="d-flex flex-column align-center pt-2">
                    <v-col cols="12" class="text-center font-weight-bold" style="font-size: 14px;">Grupo muscular</v-col>
                    <v-col cols="12" class="text-center font-weight-bold" style="font-size: 14px;">Séries</v-col>
                  </v-row>
                </v-col>

                <v-col style="overflow-x: auto;">
                  <v-row class="flex-nowrap align-center" no-gutters>
                    <v-col
                      v-for="(group, idx) in getTotalMuscleGroupSeriesFromTrainings()"
                      :key="`group-${idx}`"
                      style="min-width: 120px;"
                    >
                      <v-list-item dense class="d-flex flex-column pt-3" style="min-height: auto;">
                        <v-list-item-subtitle class="text-center">{{ group.name }}</v-list-item-subtitle>
                        <v-list-item-action class="text-center pt-3">{{ group.seriesAmount }}</v-list-item-action>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="d-flex align-center">
          <v-col cols="8">
            <v-tabs min-width="90px" v-model="tabs" background-color="white" class="training-tabs">
              <v-tab v-for="(training, index) in microcycleToBeEvaluated.trainings" :key="index">
                {{ training.name }}
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>

        <v-tabs-items v-model="tabs">
          <v-tab-item v-for="(training, idx) in microcycleToBeEvaluated.trainings" :key="idx">
            <v-container>
              <v-row class="d-flex justify-center">
                <v-col>
                  <span class="title">
                    {{ training.name }}
                  </span>
                  <template v-if="!readonly">
                    <v-btn title="Excluir Treino" class="ml-2 elevation-4" fab x-small color="secondary"
                      @click="selectTrainingToBeDestroyed(idx)" text>
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                    <v-btn title="Editar Treino" class="ml-2 elevation-4" fab x-small color="secondary" text
                      @click="editTraining(training, idx)">
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn title="Ordenar treino" class="ml-2 elevation-4" fab x-small color="secondary" text @click="settings(training, idx)">
                      <v-icon>
                      mdi-format-list-numbered
                      </v-icon>
                    </v-btn>
                    <v-btn title="Novo Treino" class="ml-2 elevation-4" fab x-small color="secondary" text @click="newTraining()">
                      <v-icon>
                      mdi-plus
                      </v-icon>
                    </v-btn>
                  </template>
                </v-col>
                <v-spacer />
                <v-btn class ="mt-3" color="primary" @click="newExerciseDialog(idx, null)">
                  <span class="mr-1"> ADICIONAR EXERCÍCIO</span>
                </v-btn>
                <v-btn class="mt-3 ml-2 elevation-3" color="secondary" text @click="selectTrainingToLibrary()">
                  <span class="ml-1">Adicionar na Biblioteca</span>
                </v-btn>
                <v-btn color="primary" @click="downloadCurrentTrainingPdf()">
                  <span class="ml-1">Baixar PDF</span>
                </v-btn>
              </v-row>
              <v-row>
                <v-col>
                  <student-training-table-micro v-for="exerciseType in getExercisesByType(idx)" :title="exerciseType.title"
                    :headers="exerciseType.headers" :items="exerciseType.items" :readonly="readonly"
                    :trainingIndex="idx" @destroyExerciseDialog="openConfirmationDestroyExerciseDialog"
                    @copyExerciseDialog="openConfirmationCopyExerciseDialog" :key="exerciseType.title" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-container>

    <template>
      <v-dialog v-model="orderDialog" persistent max-width="500">
        <v-card>
          <v-card-title>Ordenar blocos</v-card-title>
          <v-divider />
            <v-data-table no-data-text="TIpos de exercícios não encontrados" disable-pagination hide-default-footer
              :single-expand="true" item-key="value" :items="exerciseTypesOrder">
              <template v-slot:body="{ items }">
                <draggable
                  v-model="exerciseTypesOrder"
                  item-key="value"
                  ghost-class="ghost"
                  handle=".drag"
                >
                  <tr class="d-flex align-center pa-2" v-for="(item, index) in items" :key="item.value">
                    <td class="pa-0 ma-0 drag-column" style="cursor: move">
                      <v-icon class="mr-2 drag">mdi-drag</v-icon>
                    </td>
                    <td>
                      {{ item.title }} ({{ index + 1 }})
                    </td>
                  </tr>
                </draggable>
              </template>
            </v-data-table>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="orderDialog = false">Cancelar</v-btn>
            <v-btn color="primary" text @click="saveOrder">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <confirm-dialog title="Atenção" message="Deseja remover o treino selecionado? Essa ação não poderá ser desfeita"
      cancelButton="Cancelar" confirmButton="Remover" :confirmationDialog="confirmationDialog" @confirm="destroy()"
      @cancel="closeConfirmationDialog()" />

    <confirm-dialog title="Atenção" message="Deseja remover o exercício selecionado? Essa ação não poderá ser desfeita"
      cancelButton="Cancelar" confirmButton="Remover" :confirmationDialog="confirmationDestroyExerciseDialog"
      @confirm="removeExercise()" @cancel="closeConfirmationDestroyExerciseDialog()" />

    <confirm-dialog title="Atenção" message="Deseja adicionar o treino selecionado à sua biblioteca de treinos?"
      cancelButton="Cancelar" confirmButton="Adicionar" :confirmationDialog="confirmationDialogLibrary"
      @confirm="saveTrainingToLibrary" @cancel="closeConfirmationLibraryDialog()" :inputRequired="true" />

    <create-or-update-training-dialog-micro :dialog.sync="createOrUpdateTrainingDialogMicro" :editedItem="currentTraining"
      :editedIndex="currentTrainingIndex" @update="update" />

    <copy-training-dialog :cycle="cycle" :dialog.sync="confirmationCopyExerciseDialog" :editedItem="exerciseToBeCopied"
      :editedIndex="currentTrainingIndex" @update="update" />
  </dialog-full-screen>
</template>
<script>
import DialogFullScreen from '@/components/base/DialogFullScreen'
import ConfirmDialog from '@/components/base/ConfirmDialog'
import StudentHeaderInfo from '@/components/student/show/studentEvaluation/StudentHeaderInfo'
import CreateOrUpdateTrainingDialogMicro from '@/components/student/show/CreateOrUpdateTrainingDialogMicro'
import CopyTrainingDialog from '@/components/student/show/CopyTrainingDialog.vue'
import StudentTrainingTableMicro from '@/components/student/show/StudentTrainingTableMicro.vue'

import DocumentService from '@/services/document-service.js'
import StudentService from '@/services/student-service.js'
import MicrocycleService from '@/services/microcycle-service.js'
import MesocycleService from '@/services/mesocycle-service.js'
import LibraryService from '@/services/user-library-service'
import { mapGetters, mapActions } from 'vuex'
import { filter } from 'lodash'
import draggable from 'vuedraggable'

export default {
  /*eslint-disable*/
  //microcycleIsFinished:MicrocycleService.getFinalResult(this.student.id, this.macrocycleId),

  name: 'student-training-detail-micro',
  components: {
    DialogFullScreen,
    ConfirmDialog,
    StudentHeaderInfo,
    CreateOrUpdateTrainingDialogMicro,
    StudentTrainingTableMicro,
    CopyTrainingDialog,
    draggable
  },
  data() {
    return {
      week: [
        { name: 'Domingo', id: 0 },
        { name: 'Segunda', id: 1 },
        { name: 'Terça', id: 2 },
        { name: 'Quarta', id: 3 },
        { name: 'Quinta', id: 4 },
        { name: 'Sexta', id: 5 },
        { name: 'Sábado', id: 6 }
      ],
      microcycles: [],
      mesocycles: [],
      trainingListToCopy: [],
      name: '',
      microCopy: '',
      studentcopy: '',
      studentSel: '',
      thisStudent: true,
      createOrUpdateTrainingDialogMicro: false,
      currentTrainingIndex: -1,
      currentTraining: {},
      onEditTraining: false,
      tabs: null,
      confirmationDialog: false,
      confirmationDestroyExerciseDialog: false,
      trainingToBeDestroyedIndex: -1,
	    confirmationDialogLibrary: false,
      trainingToLibrary: {},
      exerciseToBeDestroyed: null,
      exerciseToBeCopied: null,
      confirmationCopyExerciseDialog: false,
      isCopyEnable: false,
	    copyMode: 'sameStudent',
      trainingsFromLibrary: [],
      resistanceHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '300' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '70' },
        { text: 'Min. Repetições', align: 'center', sortable: false, value: 'min_reps', width: '100' },
        { text: 'Max. Repetições', align: 'center', sortable: false, value: 'max_reps', width: '100' },
        { text: 'Descanso', align: 'center', sortable: false, value: 'descanco', width: '100' },
        { text: 'Cadência', align: 'center', sortable: false, value: 'cadencia', width: '100' },
        { text: 'Técnica de Intensificação', align: 'center', sortable: false, value: 'exercise_technic.name', width: '100' },
        { text: 'Grupos Musculares', align: 'center', sortable: false, value: 'muscleGroups', width: '150' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '90' }
      ],
      stretchingHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '350' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '100' },
        { text: 'Tempo', align: 'center', sortable: false, value: 'quantidade_tiros', width: '100' },
        { text: 'Descanso', align: 'center', sortable: false, value: 'descanco', width: '100' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '191' }
      ],
      mobilityHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '432' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '100' },
        { text: 'Repetições', align: 'center', sortable: false, value: 'min_reps', width: '100' },
        { text: 'Descanso', align: 'center', sortable: false, value: 'descanco', width: '200' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '110' }
      ],
      myofascialReleaseHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '350' },
        { text: 'Séries', align: 'center', sortable: false, value: 'series', width: '130' },
        { text: 'Tempo Liberação', align: 'center', sortable: false, value: 'tempo', width: '170' },
        { text: 'Intervalo', align: 'center', sortable: false, value: 'descanco', width: '100' },
        { text: 'Grupos Musculares', align: 'center', sortable: false, value: 'muscleGroups', width: '210' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '190' }
      ],
      functionalHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '300' },
        { text: 'Min. Repetições', align: 'center', sortable: false, value: 'min_reps', width: '100' },
        { text: 'Max. Repetições', align: 'center', sortable: false, value: 'max_reps', width: '100' },
        { text: 'Grupos Musculares', align: 'center', sortable: false, value: 'muscleGroups', width: '150' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '90' }
      ],
      AerobicoContHeader: [
        { text: '', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '300' },
        { text: 'Sprints', align: 'center', sortable: false, value: 'quantidade_tiros', width: '100' },
        { text: 'Duração da Sprint', align: 'center', sortable: false, value: 'tempo', width: '75' },
        { text: 'Intervalo entre Sprints', align: 'center', sortable: false, value: 'intervalo_tiros', width: '150' },
        { text: 'Freq Cardíaca', align: 'center', sortable: false, value: 'freqCardiaca', width: '100' },
        { text: 'Hiit', align: 'center', sortable: false, value: 'hiit', width: '50' },
        { text: 'Aeróbico Continuado', align: 'center', sortable: false, value: 'aerobicocont', width: '100' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '90' }
      ],
      ManobrasContHeader: [
        { text: '', align: 'left', sortable: false, value: 'draggable', width: '50' },
        { text: 'Exercício', align: 'left', sortable: false, value: 'exercise.name', width: '350' },
        { text: 'Repetições em Isometria', align: 'center', sortable: false, value: 'series', width: '130' },
        { text: 'Tempo de Cada Repetição', align: 'center', sortable: false, value: 'tempo', width: '170' },
        { text: 'Intervalo entre Cada Repetição', align: 'center', sortable: false, value: 'descanco', width: '170' },
        { text: '', align: 'left', sortable: false, value: 'actions', width: '300' }
      ],
      cycle: 'micro',
      orderDialog: false,
      exerciseTypesOrder: [
        { title: 'Alongamentos', value: 'stretching' },
        { title: 'Mobilidade', value: 'mobility' },
        { title: 'Liberação Miofascial', value: 'myofascial_release' },
        { title: 'Exercícios Funcionais', value: 'functional' },
        { title: 'Treinos Resistidos', value: 'resistence' },
        { title: 'Manobras Respiratórias/core', value: 'manobra_resp' },
        { title: 'Exercícios Aeróbicos', value: 'exerc_aerobicos' }
      ]
    }
  },
  beforeMount () {
    this.setCycleType('micro')
  },
  methods: {

    ...mapActions('base', ['fetchPdf']),
    ...mapActions('students', ['setTrainingDialogMicro', 'destroyTraining', 'setTrainingIndex',
      'setCreateOrUpdateExerciseDialog', 'destroyExercise', 'setCreateOrUpdateExercise', 'setCreateOrUpdateExerciseIndex', 'setCycleType']),
    ...mapActions('base', ['setSnackbar', 'setLoader']),
    newExerciseDialog(trainingIndex, exercise) {
      this.setTrainingIndex(trainingIndex)
      this.setCreateOrUpdateExercise(exercise)
      const exerciseIndex = this.microcycleToBeEvaluated.trainings[trainingIndex].exercises.indexOf(exercise)
      this.setCreateOrUpdateExerciseIndex(exerciseIndex)
      this.setCreateOrUpdateExerciseDialog(false)
      this.setCreateOrUpdateExerciseDialog(true)
    },
    loadMicrocycle() {
      this.setLoader({ show: true });
      var idstudent = this.student.id;

      if (this.copyMode === 'otherStudent') {
        idstudent = this.studentcopy;
        StudentService.get(idstudent)
          .then(({ data }) => {
            this.studentSel = data.student.name;
            // this.callMicrocile(idstudent);
            Promise.all([
              this.callMicrocile(idstudent),
              this.callMesocile(idstudent),
            ])
              .then(([ microcycles, mesocycles ]) => {
                this.microcycles = microcycles;
                this.mesocycles = mesocycles;
                this.trainingListToCopy = [ ...this.microcycles, ...this.mesocycles ]

                this.setSnackbar({
                  color: 'success',
                  show: true,
                  message: "Ciclos Carregados com Sucesso",
                });
              })
              .catch((error) => {
                console.error("Erro ao carregar ciclos:", error);
                this.setSnackbar({
                  color: 'error',
                  show: true,
                  message: "Erro ao Carregar Ciclos",
                });
              })
              .finally(() => {
                this.setLoader({ show: false });
              });
          })
          .catch(({ response }) => {
            this.setLoader({ show: false });
            this.setSnackbar({
              color: 'error',
              show: true,
              message: "Aluno Não Encontrado"
            });
          });
      } else {
        this.studentSel = this.student.name;
        // this.callMicrocile(idstudent);
        Promise.all([
          this.callMicrocile(idstudent),
          this.callMesocile(idstudent),
        ])
          .then(([ microcycles, mesocycles ]) => {
            this.microcycles = microcycles;
            this.mesocycles = mesocycles;
            this.trainingListToCopy = [ ...this.microcycles, ...this.mesocycles ]

            this.setSnackbar({
              color: 'success',
              show: true,
              message: "Ciclos Carregados com Sucesso",
            });
          })
          .catch((error) => {
            console.error("Erro ao carregar ciclos:", error);
            this.setSnackbar({
              color: 'error',
              show: true,
              message: "Erro ao Carregar Ciclos",
            });
          })
          .finally(() => {
            this.setLoader({ show: false });
          });
      }
    },    
    enableCopyStudent () {
      this.isCopyEnable = !this.isCopyEnable
    },
    clearStudent () {
      if (this.copyMode === 'sameStudent') {
        this.studentcopy = ""
        this.microcycles = null
        this.mesocycles = null
        this.trainingListToCopy = null
        this.studentSel = this.student.name
      }
    },
    callMicrocile(idstudent) {
      return MicrocycleService.getmicrocyclesList(idstudent)
        .then(({ data }) => {
          return data.microcycles.filter(microcycle => microcycle.id != this.microcycleToBeEvaluatedId && microcycle.trainings.length > 0);
        })
        .catch(error => {
          console.error('Error fetching microcycles:', error);
          throw error;
        });
    },
    callMesocile(idstudent) {
      return MesocycleService.getmesocyclesList(idstudent)
        .then(({ data }) => {
          return data.mesocycles.filter(mesocycle => !mesocycle.weeks && mesocycle.id != this.microcycleToBeEvaluated.mesocycle_id && mesocycle.trainings.length > 0);
        })
        .catch(response => {
          throw response;
        });
    },
    newTraining() {

      this.createOrUpdateTrainingDialogMicro = true
      this.currentTraining = Object.assign({}, {})
      this.currentTrainingIndex = -1
    },
    settings (training, index) {
      const ordem = this.microcycleToBeEvaluated.trainings[index]?.exercise_type_order
      this.exerciseTypesOrder = ordem || this.exerciseTypesOrder
      this.orderDialog = true
      this.currentTraining = Object.assign({}, training)
      this.currentTrainingIndex = index
    },
    copyTraining() {
      this.setLoader({ show: true });
      try {
        if (!this.student.id || !this.microcycleToBeEvaluated.id || !this.microCopy.id) {
          throw new Error("ID do estudante, microciclo ou microciclo para cópia não definido.");
        }

        let cycleToCopy = !Object.hasOwn(this.microCopy, 'microcycles') && !this.microCopy.name?.includes('Mesociclo')
        ? 'micro'
        : 'meso';

        MicrocycleService.selectItemToCopy(this.student.id, this.microcycleToBeEvaluated.id, this.microCopy.id, cycleToCopy, ['myLibrary', 'adminLibrary'].includes(this.copyMode));

        this.setSnackbar({
          show: true,
          color: 'success',
          message: 'Treino Copiado Com Sucesso!!'
        });
      } catch (error) {
        this.setSnackbar({
          show: true,
          color: 'error',
          message: 'Erro: ' + error.message
        });
      } finally {
        this.setLoader({ show: false });
        this.closeDialog();
      }
    },
    editTraining(training, index) {
      this.createOrUpdateTrainingDialogMicro = true
      this.currentTraining = Object.assign({}, training)
      this.currentTrainingIndex = index
    },
    closeDialog() {
      this.setTrainingDialogMicro(false)
      this.currentTraining = {}
      this.createOrUpdateTrainingDialogMicro = false
      this.$emit('updateStudantData')
    },
    update(successMessage, failMessage) {
      this.$emit('update', { successMessage, failMessage, cycle: 'micro' })
      if (successMessage) this.getTotalMuscleGroupSeriesFromTrainings()
    },
    selectTrainingToBeDestroyed(idx) {
      this.confirmationDialog = true
      this.trainingToBeDestroyedIndex = idx
    },
    destroy() {
      this.setLoader({ show: true })
      MicrocycleService.removeTraining(this.microcycleToBeEvaluated.id, this.trainingToBeDestroyedIndex)
        .then(() => {
          this.destroyTraining({trainingIndex: this.trainingToBeDestroyedIndex, cycle: 'micro'})
          this.setSnackbar({
            show: true,
            color: 'success',
            message: 'Treino removido com sucesso'
          })
          this.closeConfirmationDialog()
        })
        .catch((response) => {
          console.log(response)
          this.setSnackbar({
            color: 'error',
            show: true,
            message: response.data.errors.detail
          })
        })
        .finally(() => {
          this.setLoader({ show: false })
        })
    },
    closeConfirmationDialog() {
      this.confirmationDialog = false;
    },
    openConfirmationDestroyExerciseDialog(exercise) {
      this.exerciseToBeDestroyed = exercise
      this.confirmationDestroyExerciseDialog = true;
    },
    closeConfirmationDestroyExerciseDialog() {
      this.exerciseToBeDestroyed = null
      this.confirmationDestroyExerciseDialog = false;
    },
    openConfirmationCopyExerciseDialog(exercise, index) {
      this.currentTrainingIndex = index
      this.exerciseToBeCopied = exercise
      this.confirmationCopyExerciseDialog = true;
    },
    closeConfirmationCopyExerciseDialog() {
      this.currentTrainingIndex = -1
      this.exerciseToBeCopied = null
      this.confirmationCopyExerciseDialog = false;
    },
    getExercisesByType (idx) {
      const exercises = []
      if (this.stretchingExercises(idx) && this.stretchingExercises(idx).length) {
        exercises.push({ title: 'Alongamentos', headers: this.stretchingHeader, items: this.stretchingExercises(idx), value: 'stretching' })
      }
      if (this.mobilityExercises(idx) && this.mobilityExercises(idx).length) {
        exercises.push({ title: 'Mobilidade', headers: this.mobilityHeader, items: this.mobilityExercises(idx), value: 'mobility' })
      }
      if (this.myofascialReleaseExercises(idx) && this.myofascialReleaseExercises(idx).length) {
        exercises.push({ title: 'Liberação Miofascial', headers: this.myofascialReleaseHeader, items: this.myofascialReleaseExercises(idx), value: 'myofascial_release' })
      }
      if (this.functionalExercises(idx) && this.functionalExercises(idx).length) {
        exercises.push({ title: 'Exercícios Funcionais', headers: this.functionalHeader, items: this.functionalExercises(idx), value: 'functional' })
      }
      if (this.resistanceExercises(idx) && this.resistanceExercises(idx).length) {
        exercises.push({ title: 'Treinos Resistidos', headers: this.resistanceHeader, items: this.resistanceExercises(idx), value: 'resistence' })
      }
      if (this.respExercises(idx) && this.respExercises(idx).length) {
        exercises.push({ title: 'Manobras Respiratórias/core', headers: this.ManobrasContHeader, items: this.respExercises(idx), value: 'manobra_resp' })
      }
      if (this.respaerobic(idx) && this.respaerobic(idx).length) {
        exercises.push({ title: 'Exercícios Aeróbicos', headers: this.AerobicoContHeader, items: this.respaerobic(idx), value: 'exerc_aerobicos' })
      }

      const ordem = this.microcycleToBeEvaluated.trainings[idx]?.exercise_type_order

      const ordered = (ordem || this.exerciseTypesOrder)
        .map(order => exercises.find(e => e.value === order.value))
        .filter(Boolean)

      return ordered
    },
    removeExercise() {
      const exerciseIndex = this.microcycleToBeEvaluated.trainings[this.tabs].exercises.findIndex(exercise => {
        if (Array.isArray(exercise.exercise)) {
          // Nova estrutura: exercise é um array
          return exercise.exercise.some(ex =>
            ex.id === (Array.isArray(this.exerciseToBeDestroyed.exercise)
              ? this.exerciseToBeDestroyed.exercise[0].id
              : this.exerciseToBeDestroyed.exercise.id)
          )
        } else {
          // Estrutura antiga: exercise é um objeto
          return exercise.exercise.id === (Array.isArray(this.exerciseToBeDestroyed.exercise)
            ? this.exerciseToBeDestroyed.exercise[0].id
            : this.exerciseToBeDestroyed.exercise.id)
        }
      })

      if (exerciseIndex >= 0) {
        this.destroyExercise({ trainingIndex: this.tabs, exerciseIndex, cycle: this.cycle })
        this.update('Exercicio removido com sucesso', 'Erro ao remover Exercicio')
      } else {
        console.error('Exercício não encontrado para deleção:', this.exerciseToBeDestroyed)
        this.setSnackbar({
          color: 'error',
          show: true,
          message: 'Erro: Exercício não encontrado para remoção'
        })
      }
      this.closeConfirmationDestroyExerciseDialog()
    },
    downloadCurrentTrainingPdf() {
      if (!this.microcycleToBeEvaluated || !this.microcycleToBeEvaluated.trainings || this.microcycleToBeEvaluated.trainings.length === 0) {
        this.setSnackbar({
          color: 'error',
          show: true,
          message: 'Erro: Nenhum treino disponível para download.'
        })
        this.setLoader({ show: false })
        return
      }

      const payload = {
        studentId: this.student.id,
        macrocycleId: this.$route.params.idMacrociclo,
        mesocycleId: this.microcycleToBeEvaluated.mesocycle_id,
        microcycleId: this.microcycleToBeEvaluated.id,
        cycle: 'micro'
      }

      const trainingName = this.microcycleToBeEvaluated.trainings && this.microcycleToBeEvaluated.trainings.length > 0
        ? this.microcycleToBeEvaluated.trainings[this.tabs]?.name || 'sem nome'
        : 'sem nome'
      const tag = Object.values(payload).join('.')
      const fileName = `${tag} - ${trainingName}.pdf`

      this.setLoader({ show: true })
      this.fetchPdf({ service: DocumentService.getTrainingPdf, payload, fileName })
        .catch(error => {
          console.error('Erro ao baixar PDF:', error)
          const errorMessage = error.response && error.response.data && error.response.data.errors && error.response.data.errors.detail
            ? error.response.data.errors.detail
            : error.message || 'Erro desconhecido ao baixar PDF'
          this.setSnackbar({
            color: 'error',
            show: true,
            message: `Erro ao baixar PDF: ${errorMessage}`
          })
        })
        .finally(() => {
          this.setLoader({ show: false })
        })
    },

    isEmptyWeekdayTraining(weekday, trainings) {
      try {
        const idx = trainings.findIndex(training => {
          return training.weekdays.findIndex(w => w == weekday.id) !== -1
        })

        return idx === -1
      } catch (error) {
        return true
      }
    },
    getMuscleGroupSeriesFromWeekday(weekday, trainings, total = false) {
      var muscleGroups = {}
      var idx
      try {
        idx = trainings.findIndex(training => {
          return training.weekdays.findIndex(w => w == weekday.id) !== -1
        })


        trainings[idx].exercises.forEach(trainingExercise => {

          const exerciseArray = Array.isArray(trainingExercise.exercise) ? trainingExercise.exercise : [trainingExercise.exercise]
          exerciseArray.forEach(ex => {
            if (ex && ex.muscle_group && (!total || (!trainingExercise.series_type_id || Number(trainingExercise.series_type_id) === 1))) {
              ex.muscle_group.forEach(muscleGroup => {
                let exerciseMuscleGroup = muscleGroup.name
                if (muscleGroups[exerciseMuscleGroup] === undefined) {
                  muscleGroups[exerciseMuscleGroup] = 0
                }
                if (ex.exercise_type === 'resistence') {
                  muscleGroups[exerciseMuscleGroup] += parseInt(trainingExercise.series) || 1
                }
              })
            }
          })
        })

        const workedMuscleGroups = Object.keys(muscleGroups).map(muscleGroup => {
          return {
            name: muscleGroup,
            seriesAmount: muscleGroups[muscleGroup]
          }
        })

        return {
          name: trainings[idx].name,
          worked_muscle_groups: workedMuscleGroups.filter(item => item.seriesAmount > 0),
          exercisesCount: trainings[idx].exercises.length
        }

      } catch (error) {

        return {

          name: trainings[idx] ? trainings[idx].name : 'ERRO',
          worked_muscle_groups: [],
          exercisesCount: 0
        }
      }
    },
    getTotalMuscleGroupSeriesFromTrainings () {
      const total = {}

      this.week.forEach(weekday => {
        const result = this.getMuscleGroupSeriesFromWeekday(weekday, this.microcycleToBeEvaluated.trainings, true)
        result.worked_muscle_groups.forEach(group => {
          if (!total[group.name]) total[group.name] = 0
          total[group.name] += group.seriesAmount
        })
      })

      return Object.entries(total).map(([name, seriesAmount]) => ({ name, seriesAmount }))
    },
    getAlongamentosFromWeekday (weekday, trainings) {
      var alongamentos = 0
      var idx
      try {
        idx = trainings.findIndex(training => {
          return training.weekdays.findIndex(w => w == weekday.id) !== -1
        })


        trainings[idx].exercises.forEach(trainingExercise => {
          if (trainingExercise.exercise.exercise_type === 'resistence') {
            alongamentos += parseInt(trainingExercise.series) || 1
          }

        })


        return alongamentos

      } catch (error) {
        return 0
      }

    },
    selectTrainingToLibrary () {
      this.confirmationDialogLibrary = true
      this.trainingToLibrary = { training: this.microcycleToBeEvaluated.trainings, microcycle_id: this.microcycleToBeEvaluatedId }
    },
    closeConfirmationLibraryDialog () {
      this.confirmationDialogLibrary = false
    },
    saveTrainingToLibrary (trainingName) {
      this.setLoader({ show: true })
      this.trainingToLibrary = { ...this.trainingToLibrary, name: trainingName }
      LibraryService.createOrUpdate(this.trainingToLibrary)
        .then(() => {
          this.setSnackbar({
            show: true,
            color: 'success',
            message: 'Treino adicionado à biblioteca com sucesso'
          })
          this.closeConfirmationLibraryDialog()
        })
        .catch(({ response }) => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: response.data.errors.detail
          })
        })
        .finally(() => {
          this.setLoader({ show: false })
        })
    },
    loadLibrary (admin = false) {
      this.setLoader({ show: true })
      LibraryService.all({ admin })
        .then(({ data }) => {
          this.trainingsFromLibrary = data.trainings
        })
        .catch(({ response }) => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: 'Erro ao buscar bibliotecas'
          })
        })
        .finally(() => {
          this.setLoader({ show: false })
        })
    },
    saveOrder () {
      this.microcycleToBeEvaluated.trainings[this.currentTrainingIndex].exercise_type_order = this.exerciseTypesOrder.map((item, index) => ({
        title: item.title,
        value: item.value,
        order: index
      }))
      this.update('Ordenação salva com sucesso', 'Erro ao salvar ordenação')
      this.orderDialog = false
    }
  },
  mounted() {
    if (this.copyMode === 'sameStudent') {
      this.loadMicrocycle();
    }
  },
  computed: {
    ...mapGetters('students', ['student', 'studentTrainingDialogMicro', 'microcycleToBeEvaluated', 'cycleType']),
    ...mapGetters('auth', ['user']),

    microcycleToBeEvaluatedId() {
      return this.microcycleToBeEvaluated.id
    },

    aerobicExercises() {
      return trainingIndex => {
        try {
          return filter(this.microcycleToBeEvaluated.trainings[trainingIndex].exercises,
            (item) => item.exercise.exercise_type === 'aerobic') || []
        } catch (error) {
          return []
        }
      }
    },
    hiitExercises() {
      return trainingIndex => {
        try {
          return filter(this.microcycleToBeEvaluated.trainings[trainingIndex].exercises,
            (item) => item.exercise.exercise_type === 'hiit') || []
        } catch (error) {
          return []
        }
      }
    },
    stretchingExercises() {
      return trainingIndex => {
        try {
          return this.microcycleToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'stretching')
              }
              return item.exercise && item.exercise.exercise_type === 'stretching'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    mobilityExercises() {
      return trainingIndex => {
        try {
          return this.microcycleToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'mobility')
              }
              return item.exercise && item.exercise.exercise_type === 'mobility'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    myofascialReleaseExercises() {
      return trainingIndex => {
        try {
          return this.microcycleToBeEvaluated.trainings[trainingIndex].exercises
            .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'myofascial_release')
              }
              return item.exercise && item.exercise.exercise_type === 'myofascial_release'
            }) || []
        } catch (error) {
          return []
        }
      }
    },
    resistanceExercises() {
      return trainingIndex => {
        try {
          return this.microcycleToBeEvaluated.trainings[trainingIndex].exercises
          .filter(item => {
              if (Array.isArray(item.exercise)) {
                return item.exercise.every(ex => ex.exercise_type === 'resistence')
              }
              return item.exercise && item.exercise.exercise_type === 'resistence'
            }) || []
        } catch (error) {
          console.error('Erro ao filtrar exercícios resistidos:', error)
          return []
        }
      }
    },
    functionalExercises() {
      return trainingIndex => {
        try {
          return this.microcycleToBeEvaluated.trainings[trainingIndex].exercises
          .filter(item => {
            if (Array.isArray(item.exercise)) {
              return item.exercise.every(ex => ex.exercise_type === 'functional')
            }
            return item.exercise && item.exercise.exercise_type === 'functional'
          }) || []
        } catch (error) {
          return []
        }
      }
    },
    respExercises() {
      return trainingIndex => {
        try {
          return this.microcycleToBeEvaluated.trainings[trainingIndex].exercises
          .filter(item => {
            if (Array.isArray(item.exercise)) {
              return item.exercise.every(ex => ex.exercise_type === 'manobra_resp')
            }
            return item.exercise && item.exercise.exercise_type === 'manobra_resp'
          }) || []
        } catch (error) {
          return []
        }
      }
    },
    respaerobic() {
      return trainingIndex => {
        try {
          return this.microcycleToBeEvaluated.trainings[trainingIndex].exercises
          .filter(item => {
            if (Array.isArray(item.exercise)) {
              return item.exercise.every(ex => ex.exercise_type === 'exerc_aerobicos')
            }
            return item.exercise && item.exercise.exercise_type === 'exerc_aerobicos'
          })
          .map(v => ({
            ...v,
            aerobicocont: v.aerobicocont ? 'Sim' : 'Não'
          })) || []
        } catch (error) {
          return []
        }
      }
    },
    microcycleIsFinished() {
      const now = new Date()
      const endDate = new Date(`${this.microcycleToBeEvaluated.end_date} 23:59:59`)

      return endDate < now
    },
    isEmptyState() {
      try {
        return !(this.microcycleToBeEvaluated.trainings && this.microcycleToBeEvaluated.trainings.length > 0)
      } catch (error) {
        return true
      }
    },
    isStudent() {
      return this.user.isStudent()
    },
    readonly() {
      return this.microcycleIsFinished || this.isStudent
    },
    // consoleLogMasocycle() {
      // console.log(this.microcycleToBeEvaluated)
    // }
  },
  watch: {
    copyMode (newVal) {
      if (newVal === 'myLibrary') {
        this.loadLibrary()
      } else if (newVal === 'adminLibrary') {
        this.loadLibrary(true)
      } else if (newVal === 'sameStudent') {
        this.loadMicrocycle();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width: 1264px) {
  .container {
    max-width: 1264px;
  }
}

.lightgrey {
  background-color: #E6E6E6;
}

.training-tabs {
  border-bottom: solid grey 1px;

  .v-tab--active {
    color: grey !important;
  }
}
</style>
